import React from 'react';
import './Footer.css';

function Footer () {
  return (
    <div className="footer_container">
      <footer className="footer">
        <h5>
          © Copyright Question-mark | All Rights Reserved | Powered by CYF-team QuestionMark
        </h5>
      </footer>
    </div>
  );
}

export default Footer;
